import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
} from "@mui/material";
import moment from "moment";
import { useEffect } from "react";
import { useState } from "react";
import Auth from "../../../../../../services/Auth/Auth";
import FilesService from "../../../../../../services/Integration/files/FilesService";
import { BerkasSidangService } from "../../../../../../services/Integration/mahasiswa-sidang/BerkasSidangService";
import { DeadlineSubmisi } from "../../../../../../utils/constants/DeadlineSubmisi.constants";
import { FileHelpers } from "../../../../../../utils/helpers/File.helpers";
import BerkasSidangUploadFileField from "./BerkasSidangUploadFileField";

const berkasPPTKey = DeadlineSubmisi.jenisBerkas.PPT;
const berkasSoftcopyKey = DeadlineSubmisi.jenisBerkas["Softcopy Berkas"];
const berkasMajuSidangKey = DeadlineSubmisi.jenisSubmisi["Berkas Maju Sidang"]
const berkasPendukungKey = DeadlineSubmisi.jenisBerkas["Berkas Pendukung"];
const uploadedFilesInitialState = {
  [berkasSoftcopyKey]: null,
  [berkasPPTKey]: null,
  [berkasPendukungKey]: null,
};

export default function FileSubmissionForm({ mKSpesial, deadlines }) {
  const user = Auth.getCurrentUser();
  const [isLoading, setIsLoading] = useState({
    getData: false,
    onSubmit: false,
  });
  const [showAlert, setShowAlert] = useState({ success: false, fail: false });
  const [berkasSidang, setBerkasSidang] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState(uploadedFilesInitialState);

  useEffect(() => getFormDatas(), []);

  const getFormDatas = async () => {
    setIsLoading({ ...isLoading, getData: true });
    await getBerkasSidang();
    setIsLoading({ ...isLoading, getData: false });
  };

  const getBerkasSidang = async () => {
    await BerkasSidangService.getBerkasSidangByMkSpesialId(mKSpesial.id)
      .then((response) => {
        const berkasSidangList = response.data;
        let newBerkasSidangState = {};
        berkasSidangList.forEach((berkas) => {
          newBerkasSidangState[berkas.tipe_berkas] = berkas;
        });
        setBerkasSidang(newBerkasSidangState);
      })
      .catch((error) => console.log(error));
  };

  const getDeadlineByJenisBerkas = (jenisBerkas, jenisSubmisi) => {
    let deadline = deadlines.filter(
      (deadline) => deadline.jenis_berkas === jenisBerkas && deadline.jenis_submisi === jenisSubmisi
    );
    return deadline.length !== 0 ? deadline[0] : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading({ ...isLoading, onSubmit: true });

    let fileBase64 = {};
    await Promise.all(
      Object.entries(uploadedFiles).map(async (file) => {
        const jenisBerkas = file[0];
        const fileObj = file[1];
        if (!fileObj) return;

        await FileHelpers.fileToBase64(fileObj)
          .then(
            (result) => (fileBase64 = { ...fileBase64, [jenisBerkas]: result })
          )
          .catch((error) => console.log(error));

        let fileUploadResponseData = await FilesService.uploadFile({
          userId: user.id,
          file: fileBase64[jenisBerkas],
          prefix: `BerkasSidang_${jenisBerkas.replace(" ", "")}`,
          mKSpesialId: mKSpesial.id,
        })
          .then((response) => {
            if (response.status === 201) {
              return response.data;
            } else {
              setShowAlert({ ...showAlert, fail: true });
              return null;
            }
          })
          .catch((error) => {
            console.log(error);
            setShowAlert({ ...showAlert, fail: true });
            return null;
          });

        if (!fileUploadResponseData) {
          setIsLoading({ ...isLoading, onSubmit: true });
          return;
        }

        await BerkasSidangService.uploadBerkasSidang({
          nama_berkas: fileUploadResponseData.nama_file,
          berkas: fileUploadResponseData.id,
          tipe_berkas: jenisBerkas,
          mk_spesial: mKSpesial.id,
        })
          .then((response) => setShowAlert({ ...showAlert, success: true }))
          .catch((error) => setShowAlert({ ...showAlert, fail: true }));
      })
    );
    setIsLoading({ ...isLoading, onSubmit: false });
  };

  const handleFileUpload = (e, maxFileSize) => {
    if (!e.target.files) {
      return;
    }
    const uploadedFile = e.target.files[0];

    //dibagi 1048576 alias 1024**2 agar menjadi MegaByte
    if (uploadedFile.size / 1048576 > maxFileSize) {
      setShowAlert({ ...showAlert, fail: true });
    }
    setUploadedFiles({ ...uploadedFiles, [e.target.name]: uploadedFile });
  };

  const resetUploadedFile = (uploadedFileKey) => {
    setUploadedFiles({ ...uploadedFiles, [uploadedFileKey]: null });
  };

  const checkDisabled = (
    deadlineSoftcopy,
    deadlinePPT,
    deadlineBerkasPendukung
  ) => {
    if (!deadlineSoftcopy || !deadlinePPT || !deadlineBerkasPendukung)
      return false;
    const now = moment();
    const deadlineSoftcopyMoment = moment(
      `${deadlineSoftcopy.tanggal} ${deadlineSoftcopy.jam}`,
      "YYYY-MM-DD HH:mm:ss"
    );
    const deadlinePPTMoment = moment(
      `${deadlinePPT.tanggal} ${deadlinePPT.jam}`,
      "YYYY-MM-DD HH:mm:ss"
    );
    const deadlineBerkasPendukungMoment = moment(
      `${deadlineBerkasPendukung.tanggal} ${deadlineBerkasPendukung.jam}`,
      "YYYY-MM-DD HH:mm:ss"
    );
    return (
      now.isAfter(deadlineSoftcopyMoment) &&
      now.isAfter(deadlinePPTMoment) &&
      now.isAfter(deadlineBerkasPendukungMoment)
    );
  };

  return (
    <>
      {isLoading.getData ? (
        <LinearProgress />
      ) : (
        <>
          <div className="text-justify mb-4 flex flex-col">
            <b>Perhatian!</b>
            <small>
              Setelah mengunggah berkas, tekan tombol "Simpan" di bawah untuk
              menyimpan berkas di SISIDANG.
            </small>
          </div>
          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            <BerkasSidangUploadFileField
              title={"Berkas Tugas Akhir (Softcopy)"}
              deadline={getDeadlineByJenisBerkas(berkasSoftcopyKey, berkasMajuSidangKey)}
              inputName={berkasSoftcopyKey}
              acceptedFileTypes={".pdf"}
              onFileUpload={(e) => handleFileUpload(e, 100)}
              onResetUploadedFile={() => resetUploadedFile(berkasSoftcopyKey)}
              uploadedFile={uploadedFiles[berkasSoftcopyKey]}
              existingFile={berkasSidang[berkasSoftcopyKey]}
              maxFileSize={"100MB"}
            />
            <BerkasSidangUploadFileField
              title={"Berkas Presentasi"}
              deadline={getDeadlineByJenisBerkas(berkasPPTKey, berkasMajuSidangKey)}
              inputName={berkasPPTKey}
              acceptedFileTypes={".pdf"}
              onFileUpload={(e) => handleFileUpload(e, 100)}
              onResetUploadedFile={() => resetUploadedFile(berkasPPTKey)}
              uploadedFile={uploadedFiles[berkasPPTKey]}
              existingFile={berkasSidang[berkasPPTKey]}
              maxFileSize={"100MB"}
            />
            <BerkasSidangUploadFileField
              title={"Berkas Pendukung (jika ada)"}
              deadline={getDeadlineByJenisBerkas(berkasPendukungKey, berkasMajuSidangKey)}
              inputName={berkasPendukungKey}
              acceptedFileTypes={".zip"}
              onFileUpload={(e) => handleFileUpload(e, 100)}
              onResetUploadedFile={() => resetUploadedFile(berkasPendukungKey)}
              uploadedFile={uploadedFiles[berkasPendukungKey]}
              existingFile={berkasSidang[berkasPendukungKey]}
              maxFileSize={"100MB"}
              deskripsi={
                "Berisikan hasil eksperimen yang perlu disampaikan " +
                "atau penjelasan revisi dari sidang sebelumnya (Magister dan Doktoral). " +
                "Sedangkan program Sarjana, pada dasarnya tidak perlu mengunggah berkas pendukung."
              }
            />
            <div>
              <LoadingButton
                type="submit"
                disabled={checkDisabled(
                  getDeadlineByJenisBerkas(berkasSoftcopyKey, berkasMajuSidangKey),
                  getDeadlineByJenisBerkas(berkasPPTKey, berkasMajuSidangKey),
                  getDeadlineByJenisBerkas(berkasPendukungKey, berkasMajuSidangKey)
                )}
                loading={isLoading.onSubmit}
                variant="contained"
              >
                Simpan
              </LoadingButton>
            </div>
          </form>
        </>
      )}
      <Dialog open={showAlert.success} onClose={() => {}}>
        <DialogTitle>Berkas berhasil diunggah!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Berkas sidang anda berhasil diunggah ke SISIDANG!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowAlert({ ...showAlert, success: false });
              setUploadedFiles(uploadedFilesInitialState);
              getBerkasSidang();
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={showAlert.fail} onClose={() => {}}>
        <DialogTitle>Berkas gagal diunggah!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Terjadi permasalahan saat mengunggah berkas sidang anda! Pastikan
            anda mengunggah sesuai kriteria yang ada. Jika perlu bantuan,
            hubungi sekretariat atau admin mengenai hal ini.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowAlert({ ...showAlert, fail: false });
              setUploadedFiles(uploadedFilesInitialState);
              getFormDatas();
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
